import { IHttpClient } from '@/core/services/http'
import { AccountType } from '@/core/types/enums/account-type.enum'
import { ID } from '@/core/types/models/id.model'
import { searchLocationResolver } from '../resolvers/search-location.resolver'
import { SearchLocationResponse } from '../types/api-responses/search-location-response'

type Params = {
  search?: string
  countryId?: ID
  source?: 'from' | 'to'
}

export function createSearchLocationUseCase({
  httpClient,
}: {
  httpClient: IHttpClient
}) {
  return async function (
    { search = '', countryId, source = 'from' }: Params,
    { controller }: { controller?: AbortController } = {},
    accountType = AccountType.CUSTOMER,
  ) {
    const res = await httpClient.version('v1').post<{
      data: SearchLocationResponse
    }>(`/website/${accountType}/searchGooglePlaceByText`, {
      textQuery: search,
      country_id: countryId,
      source,
      signal: controller?.signal,
    })

    return searchLocationResolver(res.data.data.places)
  }
}
